import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReAuth } from './base-query'
import type { ListEntityDocumentsResponse, RegistryDocument, UpdateDocumentStatusBody } from './types/document'
import type { DocumentStatus, DocumentType } from './types/document'
import type { OkResponse } from './types/common'

export interface ListRentalDocumentsParams {
	rentalId: string
	type?: DocumentType
	status?: DocumentStatus
}

export const rentalDocumentsApi = createApi({
	reducerPath: 'rentalDocumentsApi',
	baseQuery: baseQueryWithReAuth,
	tagTypes: ['RentalDocument'],
	endpoints: (builder) => ({
		listRentalDocuments: builder.query<ListEntityDocumentsResponse, ListRentalDocumentsParams>({
			query: ({ rentalId, ...params }) => ({
				url: `/rent/${rentalId}/documents`,
				params,
			}),
			providesTags: (_r, _e, { rentalId }) => [{ type: 'RentalDocument', id: rentalId }],
		}),

		updateRentalDocumentStatus: builder.mutation<
			RegistryDocument | null,
			{ id: string; rentalId: string; body: UpdateDocumentStatusBody }
		>({
			query: ({ id, body }) => ({ url: `/documents/${id}/status`, method: 'PATCH', body }),
			invalidatesTags: (_r, _e, { rentalId }) => [{ type: 'RentalDocument', id: rentalId }],
		}),

		deleteRentalDocument: builder.mutation<OkResponse, { id: string; rentalId: string }>({
			query: ({ id }) => ({ url: `/documents/${id}`, method: 'DELETE' }),
			invalidatesTags: (_r, _e, { rentalId }) => [{ type: 'RentalDocument', id: rentalId }],
		}),
	}),
})

export const {
	useListRentalDocumentsQuery,
	useUpdateRentalDocumentStatusMutation,
	useDeleteRentalDocumentMutation,
} = rentalDocumentsApi

/** Alias matching old web hook name. */
export const useListDocumentsQuery = rentalDocumentsApi.useListRentalDocumentsQuery
